import { IconWaves } from "@/assets/icons/geist/IconWaves";
import { AgentExecutionStatusPill } from "@/components/ai/AgentExecutionStatusPill";
import { SidebarButton } from "@/components/SidebarButton";
import { TrackLocations } from "@/hooks/use-segment";
import { useGroupedAgentExecutions } from "@/queries/agent-queries";
import type { PlainAgentExecution } from "@/queries/agent-queries";
import { getAgentExecutionUrl } from "@/routes/ai/ai-urls";
import { useMemo, type FC } from "react";
import { useLocation } from "react-router-dom";
import { AgentExecutionContextMenu } from "@/components/ai/AgentExecutionContextMenu";
import { agentExecutionName } from "@/utils/agent-executions";

export const SidebarAgentExecutionList: FC = () => {
    const { data: groupedAgentExecutions } = useGroupedAgentExecutions();
    const agentExecutions = groupedAgentExecutions?.nonEnvironmentScoped;
    return (
        <div
            className="contents"
            data-testid="agent-execution-list"
            data-track-location={TrackLocations.SidebarAgentExecutionList}
        >
            {agentExecutions.map((agentExecution) => (
                <AgentExecution key={agentExecution.id} agentExecution={agentExecution} />
            ))}
        </div>
    );
};

const AgentExecution: FC<{ agentExecution: PlainAgentExecution }> = ({ agentExecution }) => {
    const location = useLocation();
    const url = getAgentExecutionUrl(agentExecution.id);
    const isActive = location.pathname === url;
    const name = useMemo(() => agentExecutionName(agentExecution), [agentExecution]);

    return (
        <AgentExecutionContextMenu agentExecution={agentExecution}>
            <SidebarButton
                to={url}
                active={isActive}
                label={name}
                icon={<IconWaves animating={false} className="size-6 text-content-orange" />}
                iconRight={<AgentExecutionStatusPill agentExecution={agentExecution} />}
            />
        </AgentExecutionContextMenu>
    );
};
